import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Style from "../../assets/css/home.module.css";
import bannerLarge from "../../assets/images/Shohoz-Park-Banner-1350x291.webp";
import bannerMedium from "../../assets/images/Shohoz-Park-Banner-750x291.webp";
import bannerSmall from "../../assets/images/Shohoz-Park-Banner-480x250.webp";

// const locationSuggestions = ['Dhaka', 'Chittagong', 'Sylhet', 'Khulna', 'Rajshahi', 'Barisal', 'Rangpur', 'Mymensingh', 'Cumilla', 'Narayanganj', 'Gazipur', 'Tangail', 'Narsingdi', 'Bogra', 'Jessore', 'Pabna', 'Noakhali', 'Comilla', 'Cox\'s Bazar', 'test'];
// const parkSuggestions = ['wonderland', 'Fantasy Kingdom', 'Nandan Park', 'Foy’s Lake', 'Sea World', 'Adventure World', 'Shishu Park', 'Jatra Park', 'Renaissance Park', 'Sundarbans Amusement Park', 'test'];

export default function SearchWidget({ locationSuggestions, parkSuggestions }) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    address: "",
    name: "",
  });

  // const handleChange = (event) => {
  //       const { name, value } = event.target;
  //       setFormData((prevState) => ({ ...prevState, [name]: value }));
  // };

  const [chooseLocationShow, setChooseLocationShow] = useState(false);
  const [chooseParkShow, setChooseParkShow] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    // sendSearchFormData(formData);
    if (formData.address || formData.name) {
      navigate(
        `/search-results?address=${encodeURIComponent(formData.address)}&name=${encodeURIComponent(formData.name)}`
      );
    } else {
      setChooseLocationShow(true)
      setChooseParkShow(true)
    }
  };

  // for location search start
  const [queryLocation, setQueryLocation] = useState("");
  const [filteredLocationSuggestions, setFilteredLocationSuggestions] =
    useState([]);

  const handleChangeLocation = (e) => {
    const input = e.target.value;
    setQueryLocation(input);

    const filtered = locationSuggestions.filter((item) =>
      item.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredLocationSuggestions(input ? filtered : []);

    setFormData((prev) => ({ address: "", name: prev.name }));
  };

  const handleSelectLocation = (item) => {
    setQueryLocation(item);
    setFilteredLocationSuggestions([]);

    setFormData((prev) => ({ address: item, name: prev.name }));
    setChooseLocationShow(false)
  };

  function locationInputBlur() {
    setQueryLocation(formData.address);
  }
  // for location search end

  // for park search start
  const [queryPark, setQueryPark] = useState("");
  const [filteredParkSuggestions, setFilteredParkSuggestions] = useState([]);

  const handleChangePark = (e) => {
    const input = e.target.value;
    setQueryPark(input);

    const filtered = parkSuggestions.filter((item) =>
      item.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredParkSuggestions(input ? filtered : []);

    setFormData((prev) => ({ address: prev.address, name: "" }));
  };

  const handleSelectPark = (item) => {
    setQueryPark(item);
    setFilteredParkSuggestions([]);

    setFormData((prev) => ({ address: prev.address, name: item }));
    setChooseParkShow(false)
  };

  const handleSearchInputKeyDown = (e) => {
    const keyPressed = e.key;
    const isSpecialChar = /[^a-zA-Z0-9\s]/.test(keyPressed);

    if (isSpecialChar) {
      e.preventDefault();
    }
  };

  function parkInputBlur() {
    setQueryPark(formData.name);
  }
  // for park search end

  const locationParksNotFound = (filterdList=[], query='', suggestions=[], place='') => {
    if(filterdList.length === 0 && query.length > 0 && !suggestions.includes(query)) {
      return <ul
          className="list-group position-absolute w-100 mt-2 z-3 border shadow"
          style={{ overflowY: "auto", maxHeight: "200px" }}
        >
          <button
            type="button"
            className="list-group-item list-group-item-action border-0 d-flex"
            style={{
              fontSize: "14px",
              color: "black",
            }}
          >
            <div>{`No ${place === 'park' ? 'park' : 'result'} found`}</div>
          </button>
        </ul>
      }
      return null
  }

  return (
    <div className={`${Style.home_top_banner}`}>
      <div className={`${Style.banner_wrap}`}>
        <picture className={`${Style.banner_image}`}>
          <source srcSet={bannerLarge} media="(min-width: 1200px)" />
          <source srcSet={bannerMedium} media="(min-width: 800px)" />
          <img
            src={bannerSmall}
            alt="Shohoz Park Banner"
            style={{ width: '100%', height: 'auto', display: 'block' }}
          />
        </picture>
      </div>

      <div className={`${Style.home_search_widget}`}>
        <div className={`${Style.park_search_wrapper}`}>
          <form className={`${Style.park_search_form}`} onSubmit={handleSubmit}>
            {/* Location input */}
            <label htmlFor="address" className={`${Style.form_item}`}>
              <div className={`${Style.item_icon_input_wrap}`}>
                <div className={`${Style.svg_container}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M13.9275 1.42945C14.2541 0.580255 13.4197 -0.254121 12.5705 0.0724892L0.673149 4.64842C-0.278128 5.01429 -0.202793 6.3845 0.782861 6.64385L5.69051 7.93537C5.87356 7.98353 6.01643 8.12647 6.06459 8.30945L7.35611 13.2171C7.61546 14.2028 8.98573 14.2782 9.35155 13.3268L13.9275 1.42945Z"
                      fill="#079D49"
                    />
                  </svg>
                </div>

                <div className="position-relative w-100">
                  <p className={`${Style.label_text}`}>Locations</p>
                  <input
                    type="text"
                    className={`form-control border-0 shadow-none ps-0 ${Style.form_elem}`}
                    placeholder="Search locations"
                    value={queryLocation}
                    onKeyDown={handleSearchInputKeyDown}
                    onChange={handleChangeLocation}
                    style={{ backgroundColor: "transparent", color: "black" }}
                    onBlur={locationInputBlur}
                  />

                  {filteredLocationSuggestions.length > 0 && (
                    <ul
                      className="list-group position-absolute w-100 mt-1 z-3 border shadow"
                      style={{ overflowY: "auto", maxHeight: "200px" }}
                    >
                      {filteredLocationSuggestions.map((item) => (
                        <button
                          type="button"
                          key={item}
                          className="list-group-item list-group-item-action border-0 d-flex"
                          style={{
                            cursor: "pointer",
                            fontSize: "14px",
                            color: "black",
                          }}
                          onClick={() => handleSelectLocation(item)}
                        >
                          <svg
                            width="12"
                            height="16"
                            className="me-2 mt-1"
                            viewBox="0 0 12 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.08031 0C9.2346 0 11.8403 2.65584 11.8403 5.97565C11.8403 9.24802 8.73174 13.4215 6.08031 15.034C3.38317 13.3741 0.320312 9.29545 0.320312 5.97565C0.320312 2.65584 2.88031 0 6.08031 0ZM6.08031 0.948515C3.38317 0.948515 1.2346 3.17753 1.2346 5.97565C1.2346 8.72634 3.93174 12.473 6.08031 13.8957C8.22888 12.5204 10.926 8.67891 10.926 5.97565C10.926 3.17753 8.73174 0.948515 6.08031 0.948515Z"
                              fill="#B7B7B7"
                            />
                            <path
                              d="M6.08049 2.56104C7.86335 2.56104 9.32621 4.07866 9.32621 5.97569C9.32621 7.82529 7.86335 9.34292 6.08049 9.34292C4.25192 9.34292 2.78906 7.82529 2.78906 5.97569C2.78906 4.07866 4.25192 2.56104 6.08049 2.56104ZM6.08049 3.50955C4.75478 3.50955 3.70335 4.60034 3.70335 5.97569C3.70335 7.30361 4.75478 8.3944 6.08049 8.3944C7.36049 8.3944 8.41192 7.30361 8.41192 5.97569C8.41192 4.60034 7.36049 3.50955 6.08049 3.50955Z"
                              fill="#B7B7B7"
                            />
                          </svg>

                          <div>{item}</div>
                        </button>
                      ))}
                    </ul>
                  )}
                  {locationParksNotFound(filteredLocationSuggestions, queryLocation, locationSuggestions, 'location')}
                </div>
              </div>
              {chooseLocationShow && <p className={`${Style.choose_text}`}>Please choose a location</p>}
            </label>

            {/* Park input */}
            <label htmlFor="name" className={`${Style.form_item}`}>
              <div className={`${Style.item_icon_input_wrap}`}>
                <div className={`${Style.svg_container}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="14"
                    viewBox="0 0 12 14"
                    fill="none"
                  >
                    <path
                      d="M10.2426 10.414L9.42472 11.2364C8.82184 11.8379 8.03967 12.6114 7.07779 13.5569C6.47678 14.1478 5.52323 14.1477 4.92229 13.5567L2.51663 11.1776C2.21429 10.8757 1.96121 10.6212 1.75736 10.414C-0.585785 8.03165 -0.585785 4.16909 1.75736 1.78675C4.1005 -0.595584 7.89951 -0.595584 10.2426 1.78675C12.5858 4.16909 12.5858 8.03165 10.2426 10.414ZM7.72284 6.29282C7.72284 5.3254 6.95148 4.54115 6.00001 4.54115C5.04853 4.54115 4.27716 5.3254 4.27716 6.29282C4.27716 7.26021 5.04853 8.04447 6.00001 8.04447C6.95148 8.04447 7.72284 7.26021 7.72284 6.29282Z"
                      fill="#079D49"
                    />
                  </svg>
                </div>

                <div className="position-relative w-100">
                  <p className={`${Style.label_text}`}>Parks</p>
                  <input
                    type="text"
                    className={`form-control border-0 shadow-none ps-0 ${Style.form_elem}`}
                    placeholder="Search parks"
                    value={queryPark}
                    onKeyDown={handleSearchInputKeyDown}
                    onChange={handleChangePark}
                    style={{ backgroundColor: "transparent", color: "black" }}
                    onBlur={parkInputBlur}
                  />

                  {filteredParkSuggestions.length > 0 && (
                    <ul
                      className="list-group position-absolute w-100 mt-1 z-3 border shadow"
                      style={{ overflowY: "auto", maxHeight: "200px" }}
                    >
                      {filteredParkSuggestions.map((item) => (
                        <button
                          type="button"
                          key={item}
                          className="list-group-item list-group-item-action border-0 d-flex"
                          style={{
                            cursor: "pointer",
                            fontSize: "14px",
                            color: "black",
                          }}
                          onClick={() => handleSelectPark(item)}
                        >
                          <svg
                            width="12"
                            height="16"
                            className="me-2 mt-1"
                            viewBox="0 0 12 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.08031 0C9.2346 0 11.8403 2.65584 11.8403 5.97565C11.8403 9.24802 8.73174 13.4215 6.08031 15.034C3.38317 13.3741 0.320312 9.29545 0.320312 5.97565C0.320312 2.65584 2.88031 0 6.08031 0ZM6.08031 0.948515C3.38317 0.948515 1.2346 3.17753 1.2346 5.97565C1.2346 8.72634 3.93174 12.473 6.08031 13.8957C8.22888 12.5204 10.926 8.67891 10.926 5.97565C10.926 3.17753 8.73174 0.948515 6.08031 0.948515Z"
                              fill="#B7B7B7"
                            />
                            <path
                              d="M6.08049 2.56104C7.86335 2.56104 9.32621 4.07866 9.32621 5.97569C9.32621 7.82529 7.86335 9.34292 6.08049 9.34292C4.25192 9.34292 2.78906 7.82529 2.78906 5.97569C2.78906 4.07866 4.25192 2.56104 6.08049 2.56104ZM6.08049 3.50955C4.75478 3.50955 3.70335 4.60034 3.70335 5.97569C3.70335 7.30361 4.75478 8.3944 6.08049 8.3944C7.36049 8.3944 8.41192 7.30361 8.41192 5.97569C8.41192 4.60034 7.36049 3.50955 6.08049 3.50955Z"
                              fill="#B7B7B7"
                            />
                          </svg>

                          <div>{item}</div>
                        </button>
                      ))}
                    </ul>
                  )}
                  {locationParksNotFound(filteredParkSuggestions, queryPark, parkSuggestions, 'park')}
                </div>
              </div>
              {chooseParkShow && <p className={`${Style.choose_text}`}>Please choose a park</p>}
            </label>

            <div className={`${Style.park_search_btn_wrap}`}>
              <button type="submit" className={`${Style.park_search_form_btn}`}>
                Search
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
